import { LitElement } from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import { Router } from "@vaadin/router/dist/vaadin-router.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import getProductTreeId from "../utils/getProductTreeId";
import { getParentPath } from "../lib/kblib";

/**
 * Breadcrumbs
 * @property {String} currentURL - current page location string
 * @property {Object} itemParentPath - item tree
 * @property {Object} rootPath - item tree for root node, useful as placeholder
 */

class KbHeaderParentpath extends LitElement {
  static get properties() {
    return {
      isHomepage: { type: Boolean },
      currentURL: { type: String },
      itemParentPath: { type: Object },
      rootPath: { type: Object },
      parents: { type: Array },
      langCode: { type: String },
      controlDefs: { type: Array },
      productTreeId: { type: Number },
    };
  }

  constructor() {
    super();
    this.parents = [];
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    storeInstance.dispatch("getParentPath", { extId: "ROOT" });
    this.getPageName();
    this.rootPath = this.state.root_path;
    this.productTreeId = getProductTreeId(this.state.panel_control_defs);
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  set params(value) {
    this.langCode = value.langCode;
    if (value.extId != this.externalId) {
      this.externalId = value.extId;
      // storeInstance.dispatch("getParentPath",{extId: this.externalId, langcode: this.langCode});
    }
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.rootPath = this.state.root_path;
    this.parents = [];
    this.getPageName();
    if (this.isSearchPage("pubsearch")) {
      this.setSimplePath("Publication Browse");
    } else if (this.isSearchPage("kbsearch")) {
      this.setSimplePath("Search Results");
    } else if (this.state.item_parentpath) {
      this.prepareItemPath(this.state.item_parentpath);
    }
    this.controlDefs = this.state.panel_control_defs;
    this.productTreeId = getProductTreeId(this.controlDefs);
    this.isHomepage = window.location.pathname.split("/").length < 4;
    this.myRender();
  }

  isSearchPage(pageName) {
    return this.pageName && this.pageName.includes(pageName);
  }

  getPageName() {
    this.currentURL = window.location.pathname;
    let params = this.currentURL.split("/");
    this.langCode = params[2];
    if (params.length > 2) {
      this.pageName = params[3];
    }
  }

  prepareItemPath(node) {
    if (node.itemLang) {
      var itm = {};
      itm.name = node.itemLang.name;
      itm.item = node;
      this.parents.push(itm);
      if (Array.isArray(node.children) && node.children.length > 0) {
        this.prepareItemPath(node.children[0]);
      }
    } else {
      var itm = {};
      itm.name = node.item.dfltName;
      itm.item = node;
      this.parents.push(itm);
      if (Array.isArray(node.children) && node.children.length > 0) {
        this.prepareItemPath(node.children[0]);
      }
    }
  }

  setSimplePath(pageName) {
    console.log(this.rootPath)
    this.parents.push({
      name: this.rootPath?.itemLang
        ? this.rootPath?.itemLang?.name
        : this.rootPath?.item?.dfltName,
      item: { item: this.rootPath?.item },
    });
    if (pageName) {
      this.parents.push({ name: pageName });
    }
  }

  myRender() {
    render(this.pathBreadcrumbTemplate(), this.shadowRoot);
  }

  pathBreadcrumbTemplate() {
    return html`
      <style>
        #paths {
          color: var(--kb-breadcrumbs-text-color);
          background-color: var(--kb-breadrcumbs-background);
          margin-left: 0;
          padding-left: 0.5rem;
        }
        #paths ul {
          margin: 0;
          padding: 0;
          list-style: none;
          display: inline-block;
        }
        #paths li {
          display: inline;
          font-size: 0.75rem;
          cursor: pointer;
          color: var(--kb-on-primary-color);
        }
        #paths li:hover {
          text-decoration: underline;
        }

        .empty-div {
          height: 1rem;
          background: var(--kb-header-empty-parentpath-background);
        }
        iron-icon {
          width: 0.75rem;
        }
      </style>
      ${this.isHomepage && hideBreadcrumbsOnHomepage

        ? html`<div class="empty-div"></div>`
        : html` <div id="paths">
            <ul>
              ${this.parents.map(
                (item, index) =>
                  html`<li @click="${this._gotoItem.bind(this, item)}">
                      ${item.name}
                    </li>
                    ${index < this.parents.length - 1
                      ? html`<iron-icon icon="vaadin:angle-right"></iron-icon>`
                      : null} `
              )}
            </ul>
          </div>`}
    `;
  }

  _gotoItem(item, e) {
    if (item.item.item.externalId === "ROOT") {
      Router.go("/kb/" + this.state.langCode);
    } else if (item.item.item.type === "category" && this.productTreeId) {
      Router.go(
        "/kb/" +
          this.state.langCode +
          "/pubsearch?" +
          this.productTreeId +
          "=" +
          item.item.item.externalId
      );
    } else if (item.item.item.type === "category") {
      Router.go("/kb/" + this.state.langCode + "/pubsearch");
    } else {
      Router.go("/kb/" + this.state.langCode + "/" + item.item.item.externalId);
    }
  }
  // _toggleTOC(){
  //     storeInstance.dispatch("setState", {property: "toc_open", value: !this.state.toc_open } )
  // }
}

customElements.define("kb-header-parentpath", KbHeaderParentpath);
